module.exports = __webpack_public_path__ + "static/media/road.e5292f94.png";